import React, { useState } from 'react';
import { TextField } from '@gerdau/hefesto/TextField';
import theme from '../../../../../../assets/styles/theme/theme';
import { Tooltip } from 'antd';
import { Container } from './styles';

interface ICustomerPurchaseItemInputProps {
  customerPurchaseItem: string;
  setCustomerPurchaseItem(value: string): void;
}

const CustomerPurchaseItemInput: React.FC<ICustomerPurchaseItemInputProps> = ({
  customerPurchaseItem,
  setCustomerPurchaseItem
}) => {
  const [inputValue, setInputValue] = useState(customerPurchaseItem);

  const hasError = (): boolean => {
    return inputValue.length > 6;
  };

  return (
    <Tooltip
      overlayClassName="shop-cart-input-tooltip"
      placement="top"
      title={hasError() ? `Máximo 6 caracteres` : ''}
      trigger={['hover', 'click']}
      color={theme.colors.red}
    >
      <Container>
        <TextField
          label=""
          hideLabel
          name="customerPurchaseItemInput"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onBlur={() =>
            setCustomerPurchaseItem(
              hasError() ? customerPurchaseItem : inputValue
            )
          }
        />
      </Container>
    </Tooltip>
  );
};

export default CustomerPurchaseItemInput;
